export const AicaEmailDigestSubscriptionFragment = gql`
  fragment AicaEmailDigestSubscriptionFragment on AicaEmailDigestSubscription {
    id
    uuid
    frequency
    createdAt
    updatedAt
    user {
      ...UserDataFragment
    }
  }
`
